import {Point} from "../Point";
const MAX_STACK_SIZE = 200
export class SquatDetector {
  constructor(onInitDetect, onCompleteDetect) {
    this.step = 1
    this.onInitDetect = onInitDetect
    this.onCompleteDetect = onCompleteDetect
    this.lastTime = 0

    this.distStack = []
    this.distSum = 0
    this.avg = 0

    this.detectThreshold = null
    this.resetThreshold = null
  }

  mainLoop(points) {
    // const dist = Point.dist3D(head.y, base.y)
    const dist = (Math.abs(points[26].y - points[24].y) + Math.abs(points[25].y - points[23].y)) / 2.0

    if (this.step === 1) {
      this.distStack.push(dist)
      this.distSum += dist
      if (this.distStack.length > MAX_STACK_SIZE) {
        const remove = this.distStack.shift()
        this.distSum -= remove
      }
      this.avg = this.distSum / this.distStack.length
    }

    if (Math.abs(this.avg - dist) > 0.1) {
      // console.log('skip', dist)
    }
    const now = new Date().getTime()
    if (this.step === 2) {
      if ((dist > this.avg * this.resetThreshold || dist > 0.31) && now - this.lastTime > 500) {
        this.step = 1
        this.onInitDetect()
        this.lastTime = now
      }
    } else {
      if ((dist < this.avg * this.detectThreshold || dist < 0.2) && now - this.lastTime > 500) {
        this.step = 2
        this.onCompleteDetect()
        this.lastTime = now
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detector/SquatDetector.js